export default __webpack_public_path__ + "images/c42e7d2d2a67c3271a9a944f7123a896.svg";